import { useMemo } from "react";

export default function useForkRef(refs) {
  const setRef = (ref, value) => {
    if (typeof ref === "function") {
      ref(value);
    } else if (ref != null) {
      ref.current = value;
    }
  };
  return useMemo(() => {
    if (refs.every((ref) => ref == null)) {
      return null;
    }

    return (refValue) => {
      for (const ref of refs) {
        setRef(ref, refValue);
      }
    };
  }, refs);
}
